var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"https://sbgrid.co.kr","target":"_blank"}},[_c('img',{attrs:{"src":"/images/SBGrid.png","alt":"SBGrid"}}),_c('span',{staticClass:"hd-text"},[_vm._v("SBGrid는")])]),_vm._v("  "),_c('img',{attrs:{"src":"/images/Vue.png","alt":"SBGrid"}}),_c('span',{staticClass:"hd-text"},[_vm._v("Vue Framework를 혼용하여 사용이 가능합니다.")])])
}]

export { render, staticRenderFns }